import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { authClient } from "@/lib/auth-client";
import { isConsumerSession } from "@/lib/auth-roles";

export function RiderRoute({ children }: { children: ReactNode }) {
  const { data: session, isPending: sessionPending } = authClient.useSession();
  const { data: memberRole, isPending: rolePending } = authClient.useActiveMemberRole();
  const navigate = useNavigate();

  const isConsumer = isConsumerSession(session);

  useEffect(() => {
    if (sessionPending) {
      return;
    }
    if (!session || isConsumer) {
      navigate("/auth/restaurant/sign-in");
      return;
    }
    if (rolePending) {
      return;
    }
    if (memberRole?.role !== "rider") {
      navigate("/orders");
    }
  }, [session, sessionPending, isConsumer, memberRole, rolePending, navigate]);

  if (sessionPending || rolePending) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (session && !isConsumer && memberRole?.role === "rider") {
    return <>{children}</>;
  }

  return null;
}
